import React from 'react'
import './works.css'

const otherContext = require.context('./img/pottery/other', false, /\.(png|jpg|jpeg|heic|HEIC|JPG|PNG)$/);
const other = otherContext.keys().map(otherContext);


function Other() {


    const leftTitle = (
        <div className="left-title">
            <div>
                <a href="/works/decor" className="whiteLink">| Decor</a>
            </div>
            <br />
            <div>
                <a href="/works/plates" className="whiteLink">| Plates</a>
            </div>
            <br />
            <div>
                <a href="/works/bowls" className="whiteLink">| Bowls</a>
            </div>
            <br />
            <div>
                <a href="/works/cups" className="whiteLink">| Cups</a>
            </div>
            <br />
            <div>
                <a href="/works/vases" className="whiteLink">| Vases</a>
            </div>
            <br />
            <div>
                <a href="/works/teapots" className="whiteLink">| Teapots</a>
            </div>
            <br />
            {/* <div>
                <a href="/works/videos" className="whiteLink">| Videos</a>
            </div>
            <br /> */}
            <div>
                <a href="/works/bts" className="yellowLink">| BTS</a>
            </div>
        </div>
    );

    return (
        <div className="general">
            <div className="background">
                <div className="works-title">
                    Works
                </div>
                <div className="altx">
                    <div className="altxline1"></div>
                    <div className="altxline2"></div>
                </div>
                <div className="categories">
                    <div className="category-boxing" id="otherSection">
                        {leftTitle}
                        <div className="category-flex">
                            <div className="category-title">
                                BTS
                                <br />
                                <div className="underline">______________</div>
                            </div>
                            <div className="picture-grid">
                                {other.map((picture, index) => (
                                    <img
                                    key={index}
                                    src={picture}
                                    loading="lazy"
                                    alt={`Picture ${index + 1}`}
                                    className="grid-picture"
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Other
